import React from 'react';

export interface StatCardProps {
  /** Stat icon/emoji */
  icon: string;
  /** Stat label */
  label: string;
  /** Stat title */
  title: string;
  /** Stat description */
  description: string;
}

/** Stat card component for investor section */
export const StatCard: React.FC<StatCardProps> = ({ icon, label, title, description }) => {
  const containerStyles: React.CSSProperties = {
    textAlign: 'center',
    padding: '24px',
    background: 'var(--color-white, #ffffff)',
    border: 'var(--border-width, 2px) solid var(--color-text-primary, #383838)',
  };

  const numberStyles: React.CSSProperties = {
    fontFamily: 'var(--font-mono)',
    fontSize: '32px',
    fontWeight: 700,
    color: 'var(--color-primary, #fdba74)',
    marginBottom: '8px',
  };

  const titleStyles: React.CSSProperties = {
    fontFamily: 'var(--font-mono)',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '4px',
  };

  const descStyles: React.CSSProperties = {
    fontSize: '14px',
    color: 'var(--color-text-secondary, #a1a1a1)',
  };

  return (
    <div style={containerStyles}>
      <div style={numberStyles}>
        {icon} {label}
      </div>
      <p style={titleStyles}>{title}</p>
      <p style={descStyles}>{description}</p>
    </div>
  );
};
